import { 
    FaSeedling, 
    FaSchool, 
    FaFeatherAlt, 
    FaChalkboardTeacher, 
    FaLightbulb, 
    FaClipboardList, 
    FaHandsHelping, 
    FaStar 
} from 'react-icons/fa';

const treeIntro = {
    sub: "AKCJA DRZEWO ŻYWYCH SŁÓW",
    heading: "LIST DO STAREGO DRZEWA",
    description: "Nowa inicjatywa Fundacji Dwór Imielno",
    points: [
        'Są miejsca, które pamiętają więcej niż my.',
        'Są drzewa, które widziały pokolenia, zmiany, ciszę i nadzieję.',
        'Jedno z nich rośnie przy Dworze w Imielnie.',
        'Dziś zaczynamy nową inicjatywę Fundacji Dwór Imielno – projekt oparty na uważności, pamięci, naturze i słowie.',
        'Chcemy budować mosty między przeszłością a przyszłością, między człowiekiem a miejscem, między tym, co osobiste, a tym, co wspólne.',
    ],
}

const treebenefits = [
    {
        id: 1,
        title: 'IDEA PROJEKTU',
        description: '„Słowa, które zostają” to projekt edukacyjno-literacki, którego celem jest:\n\n• rozwijanie umiejętności pisania tekstów osobistych i manifestów,\n• zachęcenie uczniów do refleksji nad światem, wartościami i przyszłością,\n• pokazanie, że słowo ma znaczenie i trwałość.\n\nManifesty napisane przez uczniów staną się częścią kapsuły czasu, która zostanie zamknięta po zakończeniu projektu i zachowana dla przyszłych pokoleń.',
        icon: <FaSeedling />
    },
    {
        id: 2,
        title: 'DLA KOGO JEST PROJEKT',
        description: 'Projekt można realizować w:\n• szkołach podstawowych (klasy IV–VIII),\n• szkołach ponadpodstawowych.\n\nForma i język manifestu powinny być dostosowane do wieku uczniów.',
        icon: <FaSchool />
    },
    {
        id: 3,
        title: 'CZYM JEST MANIFEST (DLA UCZNIA)',
        description: 'Manifest to tekst, w którym autor:\n• mówi, co jest dla niego ważne,\n• nazywa wartości, w które wierzy,\n• wyraża swoje myśli, obawy, nadzieje lub marzenia,\n• zwraca się do przyszłości, świata, ludzi lub samego siebie.\n\nManifest nie musi być polityczny. Może być osobisty, czuły, stanowczy lub refleksyjny.',
        icon: <FaFeatherAlt />
    },
    {
        id: 4,
        title: 'JAK PRZEPROWADZIĆ ZAJĘCIA (PROPOZYCJA)',
        description: 'Czas: 1–2 godziny lekcyjne\n\nEtapy:\n1️⃣ Rozmowa wprowadzająca\nCzym jest słowo, które zostaje? Czy tekst może przetrwać dłużej niż autor? Co chcielibyśmy powiedzieć ludziom za 20, 50, 100 lat?\n\n2️⃣ Praca indywidualna\nUczniowie piszą manifest w ciszy. Forma dowolna: proza, list, zapis myśli, punktowy manifest.\n\n3️⃣ (Opcjonalnie) Dzielenie się\nChętni uczniowie mogą przeczytać fragmenty swoich tekstów.',
        icon: <FaChalkboardTeacher />
    },
    {
        id: 5,
        title: 'WSKAZÓWKI DLA UCZNIÓW',
        description: 'Możesz zacząć od:\n„Wierzę, że…”\n„Chciałbym / chciałabym, żeby świat…”\n„Nie zgadzam się na…”\n„Mam nadzieję, że…”\n\nNie oceniaj siebie. Nie poprawiaj na siłę stylu. Najważniejsza jest szczerość i własny głos.',
        icon: <FaLightbulb />
    },
    {
        id: 6,
        title: 'ZASADY FORMALNE',
        description: '• Długość: 1–2 strony A4 (lub krócej u młodszych uczniów)\n• Tekst podpisany: imię, wiek/klasa, szkoła (opcjonalnie pseudonim)\n\nManifesty mogą być:\n👉 wysłane przez formularz online,\n👉 lub przekazane zbiorczo listownie przez szkołę.\n\n📌 Wszystkie manifesty nadesłane do końca 2026 roku trafią do kapsuły czasu.',
        icon: <FaClipboardList />
    },
    {
        id: 7,
        title: 'ROLA NAUCZYCIELA',
        description: 'Nauczyciel:\n• nie ocenia treści manifestu stopniem,\n• dba o bezpieczną atmosferę,\n• wspiera, ale nie ingeruje w głos ucznia.\n\nMoże wykorzystać projekt na lekcjach: języka polskiego, etyki, WOS, historii, godzinie wychowawczej.',
        icon: <FaHandsHelping />
    },
    {
        id: 8,
        title: 'DLACZEGO WARTO',
        description: 'Uczniowie:\n• uczą się odpowiedzialności za słowo,\n• doświadczają, że ich głos ma znaczenie,\n• stają się współtwórcami projektu o realnym wymiarze historycznym.',
        icon: <FaStar />
    },
];

const treesampleTasks = [
    "Niech to będą listy o:\n– tym, co ważne\n– tym, co boli lub daje nadzieję\n– wspomnieniach, marzeniach, pytaniach\n– relacji z naturą, z miejscem, z samym sobą\n\nDrzewo nie odpowie słowami.",
    "Ale może wysłucha. A my razem z nim.",
    "Jak wysłać list?\n👉 przez formularz na naszej stronie internetowej\n👉 lub tradycyjnie – listownie na adres Fundacji Dwór Imielno",
    "Wybrane listy staną się częścią archiwum projektu, inspiracją do dalszych działań, spotkań i opowieści, które – jak korzenie – zostają na długo.",
    "Zatrzymaj się na chwilę.",
    "Napisz list.",
    "Zostaw ślad.",
];

const manifestTree = [
    'Wierzymy, że: \n– miejsce ma znaczenie, \n– natura jest nauczycielką cierpliwości,\n– pamięć jest formą troski,\n– słowo ma moc zakorzeniania.',
    'Chcemy tworzyć przestrzeń, w której można się zatrzymać.',
    'Usłyszeć siebie.',
    'Uszanować to, co było.',
    'I delikatnie zaprosić to, co ma dopiero nadejść.',
    'Nie interesuje nas pośpiech ani hałas.\nInteresuje nas trwanie.\nRozmowa.',
    'Relacja człowieka z naturą, historią i drugim człowiekiem.',
    'Stare drzewo przy Dworze w Imielnie staje się symbolem tej idei – strażnikiem pamięci i cichym świadkiem współczesnych pytań.'
];

export { treebenefits, treeIntro, treesampleTasks, manifestTree };